import React from 'react';
import propTypes from 'prop-types';

/**
 * Generic component to wrap page Layouts and render a consistent Layout across all Pages of the site.
 */
const Page = ({ className, children }) => (
  <div className={`artful-client-page container-fluid ${className}`}>
    <div className="row">{children}</div>
  </div>
);

Page.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
};

export default Page;
